import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import PrepareTrackingDataHelper from '@Services/PrepareTrackingDataHelper';

export default class ToggleButtonComponent extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  getBtnClasses() {
    const { className } = this.props;
    return classnames([className, 'els-btn', 'els-btn-link', 'els-btn-right']);
  }

  getTrackingAttrs() {
    const { prepareTrackingData, expanded, isViewPreview, dataTrackingAction } = this.props;

    return prepareTrackingData
      ? {
          'data-click-delegation': 'true',
          'data-tracking': !expanded,
          'data-tracking-context': 'reactions',
          'data-tracking-preview': isViewPreview,
          'data-tracking-type': 'contentview,contentlinkclick',
          'data-tracking-action': dataTrackingAction,
          ...PrepareTrackingDataHelper.prepare(prepareTrackingData),
        }
      : [];
  }

  render() {
    const { ariaControls, expanded, toggleExpand, expandedLabel, collapsedLabel } = this.props;

    return (
      // eslint-disable-next-line react/button-has-type
      <button
        className={this.getBtnClasses()}
        aria-controls={ariaControls}
        aria-expanded={expanded}
        onClick={toggleExpand}
        {...this.getTrackingAttrs()}>
        <span>{expanded ? expandedLabel : collapsedLabel}</span>
        <svg className="els-btn-icon">
          <use xlinkHref={expanded ? '#icon-chevron-up' : '#icon-chevron-down'} />
        </svg>
      </button>
    );
  }
}

ToggleButtonComponent.propTypes = {
  className: PropTypes.string,
  ariaControls: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  toggleExpand: PropTypes.func.isRequired,
  expandedLabel: PropTypes.string.isRequired,
  collapsedLabel: PropTypes.string.isRequired,
  prepareTrackingData: PropTypes.object,
  dataTrackingAction: PropTypes.string,
  isViewPreview: PropTypes.bool,
};
